import React, { useState } from "react";
import { Chip, Box } from "@mui/material";
import { PALETTES } from "./Palettes";

const PaletteDisplay = ({selectedChip, setSelectedChip, selectedPaletteIndex, setSelectedPaletteIndex, onPaletteSelect}) => {
  

  const handleChipClick = (i) => {
    setSelectedChip(i);
    setSelectedPaletteIndex(-1);
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ 

          display: "flex",
          gap: 1,
          overflowX: "auto",
          whiteSpace: "nowrap",
          paddingBottom: 1,
          marginBottom: 2,
          maxWidth: "80vw"
     
      }}>
        {PALETTES.map((paletteGroup, i) => (
          <Chip
            key={paletteGroup.name}
            label={paletteGroup.name}
            clickable
            color={selectedChip === i ? "primary" : "default"}
            onClick={() => handleChipClick(i)}
          />
        ))}
      </Box>
      <Box sx={{ 
        display: "flex", 
        flexDirection: "row", 
        flexWrap: "wrap", 
        gap: 2,
        overflow: "scroll",
        maxHeight: "20rem",
        justifyContent: "center",
    }}>
        {PALETTES[selectedChip].palettes.map((colors, index) => index <= 19 && (
            <Palette key={index} palette={colors} isSelected={selectedPaletteIndex === index} onClick={() => {
                setSelectedPaletteIndex(index);
                // onPaletteSelect(colors);
            }}/>
          ))
        }
      </Box>
    </Box>
  );
};

export default PaletteDisplay;


export function Palette({ palette, isSelected, onClick, width=150, height=30 }) {
  return (
    <div
        style={{
            display: "flex",
            cursor: "pointer",
            border: isSelected ? "2px solid black" : "2px solid transparent",
            borderRadius: 8
        }}
        className="palette-holder"
        onClick={() => {
            onClick();
            // onPaletteSelect(palette);
            // setDisplayedPalettes(allPalettes.slice(0, rowsToShow));
        }}
        >
        {palette.map((color, colorIndex) => colorIndex <= 1 && (
            <div
            key={colorIndex}
            style={{
                backgroundColor: color,
                width: width / palette.length,
                height: height,
                borderTopLeftRadius: colorIndex == 0 ? 5 : 0,
                borderBottomLeftRadius: colorIndex == 0 ? 5 : 0,
                borderTopRightRadius: colorIndex == 1 ? 5 : 0,
                borderBottomRightRadius: colorIndex == 1 ? 5 : 0,
            }}
            />
        ))}
        </div>
  );
}